
import * as Sentry from '@sentry/react';

import { ENVIRONMENT_NAME, SEMVER, SENTRY_DSN } from 'src/config';

// 
// 

Sentry.init({
  release: SEMVER,
  environment: ENVIRONMENT_NAME,
  dsn: SENTRY_DSN,
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "offsetWidth",
    "Failed to fetch",
    "Network request failed",
    "NetworkError",
    "DOMException: Failed to read the 'localStorage' property from 'Window'",
    /Loading chunk \d+ failed. *\n*\(timeout:/g,
    /Network Error/g,
    /timeout/g,
    /The request timed out/g,
    /Request aborted/g,
  ],
  beforeSend: (event) => {
    console.log('event:', event);
    const notFoundFlightSettings = event?.breadcrumbs?.find(
      (el) =>
        el?.data?.status_code === 404 &&
        el?.data?.method === 'GET' &&
        el?.data?.url?.includes('/flight-calculator/active')
    );

    if (notFoundFlightSettings) {
      // do not send known issue
      return null;
    }

    return event;
  },
});